import { Component } from 'react'
import PropTypes from 'prop-types'
import FlagWebAPI from '@api/flag_web_api.js'
import Status from '@constants/request_statuses.ts'
import Button from '@components/Button.tsx'

export default class SpamReporter extends Component {
  constructor(props) {
    super(props)
    this.state = { status: Status.IDLE }
  }

  handleClick = e => {
    e.preventDefault
    this.reportSpam()
  }

  handleSuccess = res => {
    const type = (res.status / 100) | 0 // Note: Check if response in the 200 range
    type === 2 ? this.setState({ status: Status.SUCCEEDED }) : this.setState({ status: Status.FAILED })
  }

  handleError = err => {
    this.setState({ status: Status.FAILED })
  }

  getTextContent() {
    const { status } = this.state
    switch (status) {
      case Status.IDLE:
        return 'Report spam'

      case Status.LOADING:
        return 'Reporting...'

      case Status.FAILED:
        return 'Report failed'

      case Status.SUCCEEDED:
        return 'Reported, thanks!'
    }
  }

  reportSpam() {
    const { resourceName, resourceId } = this.props
    this.setState({ status: Status.LOADING }, () => {
      FlagWebAPI.createFlag(resourceName, resourceId).then(this.handleSuccess, this.handleError)
    })
  }

  render() {
    const { status } = this.state
    const { className } = this.props
    const text = this.getTextContent()
    if (status === Status.IDLE) {
      return (
        <Button onClick={this.handleClick} className={className} title="Report this comment as spam">
          {text}
        </Button>
      )
    } else {
      return <span className={className}>{text}</span>
    }
  }
}
SpamReporter.propTypes = {
  resourceName: PropTypes.oneOf(['Comment', 'Timeline', 'User']).isRequired,
  resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
}
SpamReporter.defaultProps = {
  className: null,
}
